<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div *ngIf="paymentDetail && payment" class="container justify-content-center">
  <h1 class="text-center lifedi-color m-3">
    รายการทางการเงิน
  </h1>

  <div class="row">
    <h4 class="col-lg-6 col-md-12 col-sm-12 text-left mt-3 lifedi-color">รหัสรายการ: {{ payment[0].PAYMENT_ID }}
    </h4>
    <div class="col-lg-6 col-md-12 col-sm-12 text-right mt-3">
      <p style="font-size: large;">หมวดหมู่:
        <span *ngIf="payment[0].TYPE === 'course'">คอร์สเรียน</span>
        <span *ngIf="payment[0].TYPE === 'consult'">กิจกรรม(consult)</span>
        <span *ngIf="payment[0].TYPE === 'workshop'">กิจกรรม(workshop)</span>
      </p>
      <p style="font-size: large;">
        ผู้ทำรายการ: {{ payment[0].USERNAME }}
      </p>
    </div>
  </div>
  <div class="row" style="margin-top: 30px;">
    <div class="col-6">
      <h4 class="text-left">{{ payment[0].PAYMENT_NAME }}</h4>
    </div>
    <div class="col-6">
      <h4 class="text-right">{{ payment[0].PRICE | number }} บาท</h4>
    </div>
  </div>

  <div class="row" *ngFor="let p of paymentDetail; let i = index">
    <div class="col-12 mb-3">
      <mat-card class="my-2">
        <div class="row">
          <div class="col-6 justify-content-left">
            <h4 class="text-left ml-2 mt-3">{{ p.TRANS_ID }}</h4>
            <p class="text-left ml-2" *ngIf="p.PAYMENT_TYPE === '2c2p'">
              ชำระผ่านทาง CREDIT CARD : THB2000 Visa ****7854
            </p>
            <p class="text-left ml-2" *ngIf="p.PAYMENT_TYPE === 'qr'">
              ชำระผ่านทาง QR Code
            </p>
            <p class="text-left ml-2"
              *ngIf="(p.PAYMENT_TYPE === 'transfer') && (p.STATUS === 'reject' || p.STATUS === 'success')">
              ชำระผ่านทางการโอน
            </p>
            <p class="text-left ml-2" *ngIf="p.STATUS === 'reject' || p.STATUS === 'success'">
              จำนวนเงิน {{ p.PRICE | number }} บาท
            </p>
            <p class="text-left ml-2" *ngIf="p.STATUS === 'reject'">หมายเหตุ: {{ p.REMARK }}</p>
          </div>

          <div class="col-6 justify-content-right">
            <p class="text-danger mr-2  mt-3 text-right" style="font-weight: bold;" *ngIf="p.STATUS === 'reject'">
              ล้มเหลว</p>
            <p class="text-success mr-2  mt-3 text-right" style="font-weight: bold;" *ngIf="p.STATUS === 'success'">
              สำเร็จ</p>
            <p class="mr-2 text-right" *ngIf="p.STATUS === 'reject' || p.STATUS === 'success'">
              {{ p.TRANFER_DATE | date }}
              <span *ngIf="p.TRANFER_HR.length > 1">{{ p.TRANFER_HR }}:</span>
              <span *ngIf="p.TRANFER_HR.length === 1">0{{ p.TRANFER_HR }}:</span>
              <span *ngIf="p.TRANFER_MIN.length > 1">{{ p.TRANFER_MIN }} น.</span>
              <span *ngIf="p.TRANFER_MIN.length === 1">0{{ p.TRANFER_MIN }} น.</span>
            </p>
            <p class="text-right mr-2" *ngIf="p.STATUS === 'reject' || p.STATUS === 'success'">
              ผู้ตรวจสอบ: {{ p.APPROVE_NAME }}
            </p>

            <button class="btn m-2 mt-3" *ngIf="p.STATUS === 'waiting_confirm'"
              (click)="verify(p.PAYMENT_ID, p.TRANS_ID)"
              style="position: absolute; right: 20px; top: -6px; background: #060e9f; color: #fff;">
              ตรวจสอบ
            </button>
          </div>
        </div>

        <!-- evidence -->
        <div *ngIf="p.STATUS === 'reject' || p.STATUS === 'success'">
          <div class="row justify-content-center collapse" [(id)]="p.TRANS_ID">
            <div class="col-4 justify-content-center">
              <h3 class="text-center m-3">หลักฐานการโอน</h3>
              <mat-card>
                <img nz-image [nzSrc]="p.TRANFER_PIC" class="img-fluid" style="width: 350px; cursor: pointer;" alt="">
              </mat-card>
            </div>
            <div *ngIf="paymentDetail[i].EVIDENCE_DATA.length > 0" class="col-8 justify-content-center">
              <h3 class="text-center m-3">หลักฐานส่วนลด</h3>

              <div class="row justify-content-center my-3">
                <div *ngFor="let ev of evidence[i]" [ngClass]="ev.length === 1 ? 'justify-content-center' : ''"
                  class="col-6 d-flex align-items-stretc">
                  <!-- image -->
                  <mat-card *ngIf="ev.TYPE_FILE === 'image'" class="evidence m-3">
                    <img nz-image class="rounded img-fluid" [nzSrc]="ev.EVIDEN_FILE" alt="">
                  </mat-card>

                  <!-- file -->
                  <mat-card *ngIf="ev.TYPE_FILE === 'file'" (click)="download(ev.EVIDEN_FILE)" class="evidence-file m-3">
                    <div class="d-flex item">
                      <img src="assets/google-docs.png" alt="">
                      <span class="file-name cut-text">
                        {{ ev.EVIDEN_ORGINAL_NAME }}
                      </span>
                    </div>
                  </mat-card>
                </div>
              </div>

              <!-- <div class="row justify-content-center my-3">
                <div *ngFor="let i of evidenceFile"
                  [ngClass]="evidenceFile.length === 1 ? 'justify-content-center' : ''" class="col-6">
                  <mat-card *ngIf="i.TYPE_FILE === 'file'" (click)="download(i.EVIDEN_FILE)" class="evidence-file m-3">
                    <div class="d-flex item">
                      <img src="assets/google-docs.png" alt="">
                      <span class="file-name cut-text">
                        {{ i.EVIDEN_ORGINAL_NAME }}
                      </span>
                    </div>
                  </mat-card>
                </div>
              </div> -->

            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-6 col-md-12 col-sm-12">
            <button *ngIf="(p.STATUS === 'success' || p.STATUS === 'reject') && p.PAYMENT_TYPE === 'transfer'"
              data-toggle="collapse" [attr.data-target]="'#' + p.TRANS_ID" class="btn ml-2 mt-3 mb-3"
              style="background: #060e9f; color: #fff;">
              ดูหลักฐานการโอน
            </button>
          </div>
          <div class="col-lg-6 col-md-12 col-sm-12 d-flex flex-row-reverse">
            <button *ngIf="p.STATUS === 'success'" class="btn ml-2 mt-3 mb-3" style="background: #060e9f; color: #fff;"
              (click)="receipt(payment[0].PAYMENT_ID)">
              ใบเสร็จต้นฉบับ
            </button>
          </div>
        </div>
      </mat-card>
    </div>

  </div>

</div>

<div *ngIf="isPrint">
  <lifedi-payment-receipt [receiptDetail]="receiptDetail" [accountId]="accountId"></lifedi-payment-receipt>
</div>